import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommerceLandingPort } from '../../../domain/commerce-registry/ports/commerce-landing.port';
import type { CommerceLanding } from '../../../domain/commerce-registry/models/commerce-landing.model';
import { ENVIRONMENT } from '../../../../environments/environment';
import { createCommerceLandingMock } from '../mocks/commerce-landing.mock';

/**
 * Used when {@link ENVIRONMENT.firebase.databaseURL} is empty (no HTTP RTDB client).
 * With `mockEnabled`, returns the dev template; otherwise returns null so guards can show `/404`.
 */
@Injectable()
export class MockCommerceLandingAdapter extends CommerceLandingPort {
  loadBySlug(slug: string, _programaSlug?: string | null): Observable<CommerceLanding | null> {
    if (!ENVIRONMENT.mockEnabled) {
      return of(null);
    }
    const data = createCommerceLandingMock(slug.trim() || 'demo');
    return of(data);
  }
}
